(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.ucwsAccessDenied = {
    isInitialized: false,
    attach: function (context, settings) {

      if (this.isInitialized === true) {
        return;
      }
      this.isInitialized = true;

      if (typeof lottie.loadAnimation === "function") {

        var jsonAnimations = drupalSettings.path.baseUrl + 'themes/ucalgary/ucws_theme/animations/';
        var $animationContainer = document.getElementById('animation');

        lottie.loadAnimation({
          container: $animationContainer,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: jsonAnimations + '403-animation.json'
        });
      }

    }
  };

})(jQuery, Drupal, drupalSettings);
